// extracted by mini-css-extract-plugin
export default {"Botao":"estilo_Botao__gNta5","Alinha":"estilo_Alinha__no3Pn"};